module.exports = __webpack_public_path__ + "648bfe6c8423e65d395a101799a4c8ce.fbx";